import * as React from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import {
  useExitPreviewMode,
  useIsOrgAdmin,
  usePreviewProgramNames,
} from 'bundles/unified-common/contexts/org-scoped/OrgScopedImpersonationContext';
import OrgScopedAdminImpersonationBanner from 'bundles/unified-home-common/components/org-scoped/OrgScopedAdminImpersonationBanner';

const OrgScopedAdminImpersonationBannerRenderer = () => {
  const isAdmin = useIsOrgAdmin();
  const programNames = usePreviewProgramNames();
  const exitPreviewMode = useExitPreviewMode();

  if (!isAuthenticatedUser() || !isAdmin) return null;

  return (
    <OrgScopedAdminImpersonationBanner programNames={programNames} onExitPreviewMode={() => exitPreviewMode?.()} />
  );
};

export default OrgScopedAdminImpersonationBannerRenderer;
